import { PineconePipelineHandler, } from "../pinecone";
class AdvancedPinecone extends PineconePipelineHandler {
    // @ts-ignore
    Index(index) {
        return this.index(index);
    }
    // @ts-ignore: hack to avoid base class inheritance issues
    index(index) {
        const apiHandler = super.indexInner(index);
        return apiHandler;
    }
}
export { AdvancedPinecone };
